{
    "locale": "ar",
    "General": {
        "OrText": "أو",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "الانتقال إلى My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "إنشاء حساب جديد",
        "ButtonText_SignInToYourAccount": "تسجيل الدخول إلى حسابك",
        "ButtonText_StartInterviewWithoutSigningUp": "بدء المقابلة دون إنشاء حساب",
        "ButtonText_StartInterviewWithoutSigningIn": "بدء المقابلة دون تسجيل الدخول",
        "Navlink_Dashboard": "لوحة التحكم",
        "Navlink_MyInterviews": "مقابلاتي",
        "Navlink_LearnWithHubert": "التعلّم مع Hubert",
        "Navlink_HelpCenter": "مركز المساعدة",
        "MyProfile": "ملفي الشخصي",
        "LogOut": "تسجيل الخروج"
    },
    "Login": {
        "MainTitle": "نتائج مقابلة Hubert",
        "Subtitle": "بعد تسجيل الدخول، يمكن الاطلاع على النتائج والحصول على الملاحظات والنصائح والمزيد.",
        "LoginTitle": "تسجيل الدخول إلى حساب Hubert",
        "Label_Email": "البريد الإلكتروني",
        "Label_Password": "كلمة المرور",
        "ButtonText_SignIn": "تسجيل الدخول",
        "ButtonText_ForgotPassword": "هل نسيت كلمة المرور؟",
        "ButtonText_ContinueWithGoogle": "المتابعة باستخدام Google",
        "OrSeparator": "أو",
        "Error_Email_Required": "يُرجى إدخال البريد الإلكتروني.",
        "Error_Email_Invalid": "يُرجى إدخال بريد إلكتروني صالح.",
        "Error_Password_Required": "يُرجى إدخال كلمة المرور.",
        "Error_Use_Same_Email_As_Interview": "يُرجى استخدام عنوان البريد الإلكتروني نفسه المستخدم في المقابلة."
    },
    "Registration": {
        "MainTitle": "نتائج مقابلة Hubert",
        "Subtitle": "يمكن إنشاء حساب للاطلاع على النتائج والحصول على الملاحظات والنصائح والمزيد.",
        "RegistrationTitle": "إنشاء حساب على Hubert",
        "BenefitsBox_Title": "يمكنك",
        "BenefitsBox_Point1": "الاطلاع على سجل مقابلاتك",
        "BenefitsBox_Point2": "تلقي ملاحظات حول أدائك في المقابلات",
        "BenefitsBox_Point3": "إعادة استخدام الإجابات في مقابلات جديدة",
        "BenefitsBox_Point4": "الحصول على نصائح للمقابلات",
        "BenefitsBox_Point5": "الاطلاع على أدلة مهنية",
        "BenefitsBox_Point6": "والمزيد",
        "Label_FirstName": "الاسم الأول",
        "Label_LastName": "اسم العائلة",
        "Label_Email": "البريد الإلكتروني",
        "Label_Password": "كلمة المرور",
        "Label_PhoneNumber": "رقم الهاتف",
        "Label_TermsOfService": "أوافق على",
        "Label_TermsOfServiceLink": "سياسة الخصوصية والشروط والأحكام",
        "Placeholder_CountryCode": "رمز الدولة",
        "Placeholder_PhoneNumber": "مثال: 07700900000",
        "HelpText_Password": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
        "ButtonText_SignUp": "إنشاء حساب",
        "ButtonText_SignUpWithGoogle": "إنشاء حساب باستخدام Google",
        "OrSeparator": "أو",
        "Error_FirstName_Required": "يُرجى إدخال الاسم الأول.",
        "Error_LastName_Required": "يُرجى إدخال اسم العائلة.",
        "Error_Email_Required": "يُرجى إدخال البريد الإلكتروني.",
        "Error_Email_Invalid": "يُرجى إدخال بريد إلكتروني صالح.",
        "Error_Email_Exists": "هذا البريد الإلكتروني مستخدم بالفعل.",
        "Error_Password_Required": "يُرجى إدخال كلمة المرور.",
        "Error_Password_6_Characters": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
        "Error_PhoneNumber_Required": "يُرجى إدخال رقم الهاتف.",
        "Error_PhoneNumber_Invalid": "رقم الهاتف غير صالح.",
        "Error_PrivacyPolicyCheck_Required": "للمتابعة، يجب الموافقة على سياسة الخصوصية والشروط والأحكام."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "قبل بدء المقابلة، وافق على شروط وأحكام استخدام Hubert بتحديد المربع أدناه.",
        "Subtitle_AfterInterviewCompleted": "يمكن إنشاء حساب للاطلاع على النتائج والحصول على الملاحظات والنصائح والمزيد.",
        "PrivacyPolicyText": "بالنقر على «إنشاء حساب»، فإنك توافق على",
        "PrivacyPolicyLink": " سياسة الخصوصية والشروط والأحكام",
        "ButtonText_SignUp": "إنشاء حساب وبدء المقابلة",
        "ButtonText_SignUpNormal": "إنشاء حساب",
        "ButtonText_SignInInstead": "تسجيل الدخول بدلًا من ذلك"
    },
    "LoginInviteEmail": {
        "Subtitle": "بعد تسجيل الدخول، يمكن الاطلاع على النتائج والحصول على الملاحظات والنصائح والمزيد."
    },
    "AppMessages": {
        "internal-server-error": "حدث خطأ غير متوقع.",
        "invalid-credentials": "بيانات تسجيل الدخول غير صحيحة. يُرجى المحاولة مرة أخرى.",
        "user-not-found": "بيانات تسجيل الدخول غير صحيحة. يُرجى المحاولة مرة أخرى.",
        "account-not-found": "تعذر العثور على هذا الحساب. يُرجى المحاولة مرة أخرى.",
        "verify-email-title": "تأكيد البريد الإلكتروني",
        "verify-email-subtitle": "يُرجى التحقق من البريد الإلكتروني وتأكيد الحساب.",
        "email-not-verified-title": "لم يتم تأكيد البريد الإلكتروني",
        "email-not-verified-subtitle": "يُرجى التحقق من البريد الإلكتروني وتأكيد الحساب.",
        "verifying-email-title": "جارٍ تأكيد البريد الإلكتروني",
        "verifying-email-subtitle": "يُرجى الانتظار...",
        "sign-in-title": "جارٍ تسجيل الدخول",
        "sign-in-subtitle": "يُرجى الانتظار...",
        "server-error": "حدث خطأ ما.",
        "hubert-user-exists": "الحساب موجود بالفعل.",
        "account-exists": "الحساب موجود بالفعل.",
        "email-verified": "تم تأكيد بريدك الإلكتروني.",
        "email-is-taken": "هذا البريد الإلكتروني مستخدم بالفعل.",
        "re-enter-password": "يُرجى تسجيل الدخول باستخدام كلمة المرور.",
        "password-reset": "تم تغيير كلمة المرور.",
        "re-enter-new-password": "يُرجى تسجيل الدخول باستخدام كلمة المرور الجديدة.",
        "invalid-invitation": "رابط الدعوة غير صالح.",
        "invalid-code": "رمز التحقق غير صالح.",
        "email-already-verified": "تم تأكيد البريد الإلكتروني بالفعل.",
        "email-mismatch-title": "البريد الإلكتروني غير متطابق",
        "email-mismatch-subtitle": "يُرجى استخدام عنوان البريد الإلكتروني نفسه المستخدم عند التقديم على الوظيفة."
    },
    "TransitionPage": {
        "loading-title": "جارٍ التحميل...",
        "loading-subtitle": "جارٍ تجهيز بياناتك...",
        "logout-title": "جارٍ التحميل...",
        "logout-subtitle": "جارٍ تسجيل خروجك..."
    },
    "ImpersonationPage": {
        "loading-title": "جارٍ التحميل...",
        "loading-subtitle": "جارٍ تجهيز بياناتك..."
    },
    "ProcessInvitation": {
        "loading-title": "جارٍ التحميل...",
        "loading-subtitle": "يُرجى الانتظار بينما نجهّز مقابلتك.",
        "InvitationNotFound": "تعذر العثور على مقابلتك.",
        "InvitationExpired": "انتهت صلاحية رابط الوصول إلى هذه المقابلة.",
        "InvitationExpired_Description1": "يُرجى فتح المقابلة من",
        "InvitationExpired_Description2": "أو التواصل مع فريق التوظيف.",
        "InvitationInvalid": "رابط الدعوة إلى المقابلة غير صالح.",
        "InterviewCompleted": "أُكملت هذه المقابلة بالفعل."
    },
    "Common": {
        "MyInterviews": {
            "Title": "مقابلاتي",
            "TableHead_Employer": "جهة العمل",
            "TableHead_Job": "الوظيفة",
            "TableHead_Status": "الحالة",
            "TableHead_ApplicationDate": "تاريخ التقديم",
            "TableBody_StartInterview": "لم تكتمل المقابلة بعد. يمكنك بدءها أو استئنافها من هنا.",
            "TableBody_NotScored": "اكتملت المقابلة، وستتوفر النتائج قريبًا.",
            "TableBody_Details": "عرض نتائج المقابلة وتفاصيلها.",
            "ApplicationDate_Invited": "تمت دعوتك",
            "ApplicationDate_MinuteAgo": "دقيقة مضت",
            "ApplicationDate_MinutesAgo": "دقائق مضت",
            "ApplicationDate_HourAgo": "ساعة مضت",
            "ApplicationDate_HoursAgo": "ساعات مضت",
            "ApplicationDate_DayAgo": "يوم مضى",
            "ApplicationDate_DaysAgo": "أيام مضت",
            "ButtonText_SeeAllInterviews": "عرض جميع المقابلات",
            "ButtonText_Details": "التفاصيل",
            "ButtonText_StartInterview": "بدء المقابلة",
            "ButtonText_NotScored": "النتائج قيد الانتظار",
            "NoInterviews_Message": "لا توجد مقابلات سابقة أو قادمة."
        },
        "LatestJobPostings": {
            "NoJobPostings": "لا توجد إعلانات وظائف متاحة حاليًا. يُرجى التحقق مرة أخرى لاحقًا."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "مساري المهني",
            "Subtitle": "يمكن اختيار مقابلة للاطلاع على التقييم والفرص المهنية.",
            "MostRecentInterview": "أحدث مقابلة",
            "ToDo": "المهام",
            "NoOngoingInterviews_Title": "لا توجد دعوات جديدة إلى مقابلات حتى الآن.",
            "NoOngoingInterviews_Subtitle": "ستظهر هنا أي مقابلة جديدة مع Hubert فور وصول دعوة من فريق التوظيف.",
            "NoRecentInterviews_Title": "لا توجد مقابلات سابقة حتى الآن.",
            "NoRecentInterviews_Subtitle": "عندما تتلقى دعوة إلى مقابلة، ستظهر هنا.",
            "ButtonText_StartInterview": "بدء المقابلة",
            "ButtonText_NotScored": "النتائج قيد الانتظار",
            "ButtonText_Details": "التفاصيل"
        },
        "LearnWithHubert": {
            "Title": "التعلّم مع Hubert",
            "Subtitle": "نصائح لتطوير مهاراتك في المقابلات وتعزيز أدائك المهني.",
            "PickedForMe": "أحدث المقالات",
            "ButtonText_SeeAllArticles": "عرض جميع المقالات"
        },
        "HubertTip": {
            "Title": "نصيحة Hubert",
            "Subtitle": "أنجز مقابلاتك بشكل أسرع",
            "Description": "إذا تقدّمت إلى وظيفة مشابهة لوظيفة سبق أن أجريت لها مقابلة مع Hubert، يمكنك إعادة استخدام إجاباتك السابقة وتوفير الوقت.",
            "ButtonText_ReadMoreTips": "اطّلع على مزيد من النصائح"
        },
        "NewCandidateModalPopup": {
            "Title": "أنت جاهز!",
            "DescriptionLine1": "حسابك جاهز الآن.",
            "DescriptionLine2": "يمكنك الآن إدارة مقابلاتك وملفك الشخصي، والاطلاع على نتائجك وملاحظاتك، ومعرفة المزيد عن مقابلات Hubert.",
            "ButtonText_LetsGo": "لنبدأ"
        },
        "InterviewCompletedModal": {
            "Title": "عمل رائع!",
            "Subtitle": "لقد أكملت مقابلتك.",
            "Description": "سيُراجع فريق التوظيف جميع الطلبات، وسيتم التواصل عبر البريد الإلكتروني أو الهاتف عند وجود مستجدات.",
            "ButtonText_Continue": "متابعة"
        },
        "LatestJobPostings": {
            "Title": "أحدث إعلانات الوظائف",
            "Subtitle": "فرص أخرى نشرها شركاء Hubert مؤخرًا."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "مقابلاتي",
        "MyInterviewsSection_Subtitle": "يمكن اختيار مقابلة للاطلاع على التقييم والفرص المهنية المتاحة.",
        "MyInterviewsSection_ToDo": "المهام"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "عرض جميع المقابلات",
        "InterviewNotFound_Title": "المقابلة غير متاحة",
        "InterviewNotFound_Description": "لا يمكنك عرض تفاصيل مقابلة غير مرتبطة بحسابك.",
        "ButtonText_GoToAllInterviews": "الانتقال إلى مقابلاتي",
        "InterviewDetails": {
            "Title": "تفاصيل المقابلة",
            "ForRole": "الدور الوظيفي",
            "InterviewCompletedOn": "أُكملت المقابلة في {{date}} الساعة {{time}}"
        },
        "MyResult": {
            "Title": "نتيجتي",
            "Subtitle": "درجة التوافق",
            "ButtonText_LearnMore": "كيف يقيّم Hubert إجاباتك؟",
            "GotPotential_Title": "إمكانات قوية مع متطلب غير مستوفى",
            "GotPotential_Description": "تُظهر الإجابات إمكانات قوية لهذا النوع من الأدوار. لكن قد يكون هناك متطلب واحد أو أكثر خاص بهذه الوظيفة لم يُستوفَ، وقد يؤثر ذلك في الخطوات التالية بحسب احتياجات فريق التوظيف ومستوى المنافسة بين طلبات التقديم. وإذا لم ينتقل الطلب إلى المرحلة التالية، فلا يعني ذلك بالضرورة محدودية الإمكانات المهنية؛ فقد يكون الأمر ببساطة مرتبطًا بمدى الملاءمة لاحتياجات هذا الدور تحديدًا. تظهر أدناه فرص أخرى ونصائح للتطور.",
            "GotPotential_DescriptionSecondary": "تقييم Hubert استرشادي وليس قرارًا نهائيًا. يتخذ فريق التوظيف القرار النهائي، وقد تتأثر النتيجة بعوامل أخرى مثل عدد طلبات التقديم.",
            "GreatMatch_Title": "توافق قوي",
            "GreatMatch_Description": "تتوافق الإجابات بشكل قوي مع ما تبحث عنه فرق التوظيف عادةً في هذا الدور، كما أن متطلبات الوظيفة مستوفاة. أداء ممتاز. سيُراجع الطلب ضمن بقية طلبات التقديم، ثم تحدد جهة التوظيف الخطوات التالية.",
            "GreatMatch_DescriptionSecondary": "تقييم Hubert استرشادي وليس قرارًا نهائيًا. يتخذ فريق التوظيف القرار النهائي، وقد تتأثر النتيجة بعوامل أخرى مثل عدد طلبات التقديم. وعدم الانتقال إلى المرحلة التالية لا يعني بالضرورة محدودية الإمكانات المهنية؛ فقد يتعلق الأمر بمدى الملاءمة لاحتياجات الدور. تظهر أدناه فرص أخرى ونصائح للتطور.",
            "OkMatch_Title": "استيفاء المتطلبات مع فرصة لتعزيز إجاباتك",
            "OkMatch_Description": "تُظهر الإجابات استيفاء متطلبات الوظيفة. ولتعزيز أثرها، يمكن زيادة وضوحها وتحديدها بما يتوافق مع ما تبحث عنه فرق التوظيف عادةً في هذا الدور. تظهر أدناه مواضع قد يرفع فيها المثال الملموس أو النتيجة الواضحة من جودة الإجابة.",
            "OkMatch_DescriptionSecondary": "تقييم Hubert استرشادي وليس قرارًا نهائيًا. يتخذ فريق التوظيف القرار النهائي، وقد تتأثر النتيجة بعوامل أخرى مثل عدد طلبات التقديم.",
            "NotClearMatch_Title": "التوافق غير واضح حتى الآن",
            "NotClearMatch_Description": "بناءً على هذه المقابلة، قد لا تتوافق الإجابات بالقدر الكافي مع ما يبحث عنه فريق التوظيف في هذا الدور، أو قد يكون هناك متطلب واحد أو أكثر لم يُستوفَ. يمكن البدء بالأسئلة أدناه لتحسين الأداء؛ فمزيد من التحديد، وأمثلة أوضح، ونتائج ملموسة قد تُحدث فرقًا كبيرًا في المرة القادمة.",
            "NotClearMatch_DescriptionSecondary": "تقييم Hubert استرشادي وليس قرارًا نهائيًا. يتخذ فريق التوظيف القرار النهائي، وقد تتأثر النتيجة بعوامل أخرى مثل عدد طلبات التقديم."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "الخبرات المهنية والدوافع والكفاءات",
            "QualifyingRequirements": "المتطلبات الأساسية لهذه الوظيفة",
            "NotQualified_Title": "مجال للتحسين",
            "NotQualified_Description": "قد تكون بعض الإجابات أقل تحديدًا أو تركيزًا على النتائج مما يبحث عنه فريق التوظيف لهذا الدور. توضح المواضع أدناه أين يمكن لمثال ملموس أو خطوات واضحة أو نتيجة محددة أن تجعل الإجابة أقوى.",
            "GreatResults_Title": "إجابات قوية",
            "GreatResults_Description": "تُظهر الإجابات ملاءمة جيدة لهذا النوع من الأدوار ووضوحًا في التواصل. وتظهر أدناه الأسئلة التي يمكن تعزيز الإجابات عنها.",
            "MeetingRequirements_Title": "استيفاء المتطلبات",
            "MeetingRequirements_Description": "تُظهر الإجابات استيفاء المتطلبات الأساسية المحددة لهذه الوظيفة، وهذا أساس جيد.",
            "NotAllExpectationsMet_Title": "متطلب واحد أو أكثر غير مستوفى",
            "NotAllExpectationsMet_Description": "بناءً على الإجابات، قد يكون هناك متطلب أساسي واحد أو أكثر لهذه الوظيفة لم يُستوفَ، مثل الشهادات أو التراخيص أو المستوى التعليمي أو سنوات الخبرة.",
            "ButtonText_FindOutPossibleReasons": "عرض التفاصيل"
        },
        "ScriptFromInterview": {
            "Title": "النص الكامل للمقابلة",
            "ButtonText_SeeWholeTranscript": "عرض نص المقابلة",
            "ButtonText_DeleteInterview": "حذف المقابلة",
            "Loading_Title": "جارٍ التحميل...",
            "Loading_Subtitle": "يُرجى الانتظار بينما نحمّل نص المقابلة."
        },
        "HowToImproveAtInterviews": {
            "Title": "تحسين الأداء في المقابلات",
            "Subtitle_Questions": "فيما يلي أسئلة يمكنك تعزيز إجاباتك عنها.",
            "Subtitle_NoQuestions": "لم نحدد إجابات بعينها تحتاج إلى تحسين. إليك طرقًا يمكن أن تجعل إجاباتك أكثر تأثيرًا في هذا الدور.",
            "GreatMatch_Questions_Description": "حتى مع وجود توافق قوي، قد تستفيد بعض الإجابات من مزيد من الصقل. ستظهر أدناه إذا تم تحديدها. يُرجى اتباع التعليمات التي تسبق كل سؤال، ومع كل موقف يُفضّل توضيح السياق، وما تم فعله، والنتيجة المحققة. ويُفضّل عدم الاكتفاء بإجابة مثل «حسنًا» عند طلب التوضيح، مع تجنّب الإطالة غير الضرورية؛ فالإجابات الواضحة والمحددة أقوى، كما في المقابلة وجهًا لوجه.",
            "GreatMatch_NoQuestions_Description": "إجابات جيدة. أداء ممتاز.",
            "OkMatch_Questions_Description": "تظهر أدناه أسئلة يمكن تعزيز الإجابات عنها. يُرجى اتباع التعليمات التي تسبق كل سؤال، ومع كل موقف يُفضّل توضيح السياق، وما تم فعله، والنتيجة المحققة. ويُفضّل عدم الاكتفاء بإجابة مثل «حسنًا» عند طلب التوضيح، مع تجنّب الإطالة غير الضرورية؛ فالإجابات الواضحة والمحددة أقوى، كما في المقابلة وجهًا لوجه.",
            "OkMatch_NoQuestions_Description": "إجاباتك جيدة، لكن المنافسة على هذه الوظيفة قد تكون قوية، ولذلك قد تحتاج إلى إبراز ما يميزك بوضوح أكبر.",
            "OkMatch_NoQuestions_DescriptionSecondary": "في المرة القادمة، يُفضّل التركيز على الوضوح والأثر: البدء بالنتيجة، ثم إضافة مثال حقيقي واحد، مع الحفاظ على الإيجاز — عادةً بين 3 و6 جمل. ويُفضّل توضيح ما تحقق، والخطوات التي أدت إليه، وما الذي تغيّر نتيجة لذلك.",
            "GotPotential_Questions_Description": "حتى مع وجود إمكانات قوية لهذا النوع من الوظائف، قد تستفيد بعض الإجابات من مزيد من الصقل. ستظهر أدناه إذا تم تحديدها. يُرجى اتباع التعليمات التي تسبق كل سؤال، ومع كل موقف يُفضّل توضيح السياق، وما تم فعله، والنتيجة المحققة. ويُفضّل عدم الاكتفاء بإجابة مثل «حسنًا» عند طلب التوضيح، مع تجنّب الإطالة غير الضرورية؛ فالإجابات الواضحة والمحددة أقوى، كما في المقابلة وجهًا لوجه.",
            "GotPotential_NoQuestions_Description": "لم نجد إجابات تحتاج إلى تحسين كبير فيما يتعلق بكفاءاتك المهنية ودوافعك. تبدو إجاباتك في هذه الجوانب جيدة.",
            "NotClearMatch_Questions_Description": "تظهر أدناه أسئلة يمكن تعزيز الإجابات عنها. يُرجى اتباع التعليمات التي تسبق كل سؤال، ومع كل موقف يُفضّل توضيح السياق، وما تم فعله، والنتيجة المحققة. ويُفضّل عدم الاكتفاء بإجابة مثل «حسنًا» عند طلب التوضيح، مع تجنّب الإطالة غير الضرورية؛ فالإجابات الواضحة والمحددة أقوى، كما في المقابلة وجهًا لوجه.",
            "NotClearMatch_NoQuestions_Description": "لم نجد إجابة واحدة يمكن وصفها بأنها «سيئة». المسألة تتعلق بمدى توافق إجاباتك إجمالًا مع احتياجات هذا الدور، وقد تصبح الفروق الصغيرة مؤثرة عندما تكون المنافسة قوية.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "في المقابلة القادمة، يُفضّل التركيز على الأمثلة الملموسة. لكل سؤال، يمكن اختيار مثال واحد وشرح ما حدث، والدور الذي تم القيام به، والنتيجة المحققة. غالبًا ما تكون الإجابة القصيرة والمحددة أقوى من الإجابة الطويلة والعامة.",
            "Alert_WantMoreAdvice": "لمزيد من النصائح حول تحسين أدائك في مقابلات Hubert،",
            "AlertLink_ExploreOurGeneralAdviceArticle": "اطّلع على مقال النصائح العامة"
        },
        "SimilarOffers": {
            "Title": "عروض مشابهة"
        },
        "HowHubertScoresInterviews": {
            "Title": "كيف يقيّم Hubert المقابلات؟",
            "Description": "إليك شرحًا موجزًا لكيفية تقييم Hubert لإجاباتك، وما يحدث بعد المقابلة خلال مراحل التوظيف التالية.",
            "Tabs_PossibleOutcomes": "النتائج المحتملة",
            "Tabs_RecruitmentProcess": "عملية التوظيف",
            "AssessedMatch_Title": "تقييم مدى التوافق",
            "AssessedMatch_Description": "يقيّم Hubert الإجابات إجمالًا مقارنةً بما تبحث عنه فرق التوظيف عادةً في هذا الدور. وبالاستناد أيضًا إلى متطلبات الوظيفة، تظهر إحدى النتائج التالية.",
            "AssessedMatch_DescriptionSecondary": "تقييم Hubert استرشادي وليس قرارًا نهائيًا. يتخذ فريق التوظيف القرار النهائي، وقد تتأثر النتيجة بعوامل أخرى مثل عدد طلبات التقديم.",
            "GreatMatch_Title": "توافق قوي",
            "GreatMatch_Description": "تتوافق الإجابات بشكل قوي مع ما تبحث عنه فرق التوظيف عادةً في هذا الدور، كما أن متطلبات الوظيفة مستوفاة. أداء ممتاز. سيُراجع الطلب ضمن بقية طلبات التقديم، ثم تحدد جهة التوظيف الخطوات التالية.",
            "GotPotential_Title": "إمكانات قوية مع متطلب غير مستوفى",
            "GotPotential_Description": "تُظهر الإجابات إمكانات قوية لهذا النوع من الأدوار. لكن قد يكون هناك متطلب واحد أو أكثر خاص بهذه الوظيفة لم يُستوفَ، وقد يؤثر ذلك في الخطوات التالية بحسب احتياجات فريق التوظيف ومستوى المنافسة بين طلبات التقديم.",
            "OkMatch_Title": "استيفاء المتطلبات مع فرصة لتعزيز إجاباتك",
            "OkMatch_Description": "تُظهر الإجابات استيفاء متطلبات الوظيفة. ولتعزيز أثرها، يمكن زيادة وضوحها وتحديدها بما يتوافق مع ما تبحث عنه فرق التوظيف عادةً في هذا الدور. ويمكن أن تساعد ملاحظات المقابلة على تقديم أمثلة ونتائج أقوى مستقبلًا.",
            "NotClearMatch_Title": "التوافق غير واضح حتى الآن",
            "NotClearMatch_Description": "بناءً على هذه المقابلة، قد لا تتوافق الإجابات بالقدر الكافي مع ما يبحث عنه فريق التوظيف في هذا الدور، وقد يكون هناك متطلب واحد أو أكثر لم يُستوفَ. توضح الإجابات المواضع التي يمكن فيها إضافة مزيد من الوضوح والأمثلة والنتائج.",
            "ProfessionalExperiences_Title": "الخبرات المهنية والدوافع والكفاءات",
            "ProfessionalExperiences_Description": "تتناول هذه الأسئلة الخبرات السابقة، والدوافع تجاه الوظيفة، والكفاءات المرتبطة بالدور. وتحدد فرق التوظيف الأسئلة المستخدمة في مقابلة كل وظيفة.",
            "GreatResults_Title": "إجابات قوية",
            "GreatResults_Description": "تُظهر إجاباتك ملاءمة جيدة لهذا النوع من الأدوار ووضوحًا في التواصل. وتظهر داخل المقابلة الإجابات التي يمكن تعزيزها.",
            "NotQualified_Title": "مجال للتحسين",
            "NotQualified_Description": "قد تكون بعض الإجابات أقل تحديدًا أو تركيزًا على النتائج مما يبحث عنه فريق التوظيف لهذا الدور. وتوضح المواضع المميّزة أين يمكن لمثال ملموس أو خطوات واضحة أو نتيجة محددة أن تجعل الإجابات أقوى.",
            "QualifyingRequirements_Title": "المتطلبات الأساسية لهذه الوظيفة",
            "QualifyingRequirements_Description": "تتحقق هذه الأسئلة من استيفاء المتطلبات الأساسية التي حددها فريق التوظيف، مثل شهادة مطلوبة أو رخصة قيادة أو مستوى معين من الخبرة ذات الصلة.",
            "MeetingRequirements_Title": "استيفاء المتطلبات",
            "MeetingRequirements_Description": "تُظهر الإجابات استيفاء المتطلبات الأساسية التي حددها فريق التوظيف لهذه الوظيفة، وهذا أساس جيد.",
            "NotAllExpectationsMet_Title": "متطلب واحد أو أكثر غير مستوفى",
            "NotAllExpectationsMet_Description": "بناءً على الإجابات، قد يكون هناك متطلب أساسي واحد أو أكثر لهذه الوظيفة لم يُستوفَ، مثل الشهادات أو التراخيص أو المستوى التعليمي أو سنوات الخبرة.",
            "RecruitmentProcess_Title": "عملية التوظيف",
            "RecruitmentProcess_Description": "يُستخدم Hubert عادةً كخطوة أولى في عمليات التوظيف التي تستقبل عددًا كبيرًا من طلبات التقديم. وبهذا تتاح للجميع فرصة إجراء مقابلة والتعبير بصياغة شخصية. ولأن الأسئلة نفسها تُطرح في جميع المقابلات للوظيفة نفسها، تصبح العملية أكثر اتساقًا. كما أن Hubert لا يستخدم معلومات مثل العمر أو الجنس أو الأصل العرقي أو الدين أو المظهر، ما يساعد على الحد من احتمالات التحيّز اللاواعي.",
            "EventOne_Title": "إجراء مقابلة مع Hubert",
            "EventOne_Description": "يمكنك إجراء مقابلة Hubert في الوقت والمكان المناسبين لك. لا يوجد حد زمني، ويمكنك أخذ استراحة في أي وقت ثم استئناف المقابلة من حيث توقفت.",
            "EventTwo_Title": "تقييم المقابلة",
            "EventTwo_Description": "يقيّم Hubert الإجابات باستخدام تقنيات حديثة. وبعد اكتمال التقييم، تظهر النتائج هنا في My Hubert، كما تصبح متاحة لفريق التوظيف في نظام طلبات التوظيف.",
            "EventThree_Title": "اختيار الطلبات للمرحلة التالية",
            "EventThree_Description": "عند توفر نتيجة جديدة لمقابلة Hubert، يمكن لفريق التوظيف مراجعة الإجابات وتقييم Hubert في نظام طلبات التوظيف. وبالاستناد إلى تقييم Hubert الاسترشادي والتقدير المهني للفريق، تُحدد الطلبات التي تنتقل إلى الخطوة التالية، التي قد تكون مكالمة هاتفية أو اختبارًا أو مقابلة نهائية. وقد يستغرق اتخاذ القرار بعض الوقت في بعض الحالات، وإذا كانت طلبات أخرى أكثر توافقًا مع الدور، فقد لا ينتقل الطلب إلى المرحلة التالية.",
            "ButtonText_Close": "إغلاق"
        }
    },
    "MyProfile": {
        "Title": "ملفي الشخصي",
        "MyDetails": {
            "Title": "بياناتي",
            "Label_FirstName": "الاسم الأول",
            "Label_LastName": "اسم العائلة",
            "Label_Email": "البريد الإلكتروني",
            "Label_PhoneNumber": "رقم الهاتف",
            "ButtonText_UpdateDetails": "حفظ التغييرات",
            "Error_FirstName_Required": "يُرجى إدخال الاسم الأول.",
            "Error_LastName_Required": "يُرجى إدخال اسم العائلة.",
            "Error_Email_Required": "يُرجى إدخال البريد الإلكتروني.",
            "Error_Email_Invalid": "يُرجى إدخال بريد إلكتروني صالح.",
            "Error_PhoneNumber_Invalid": "رقم الهاتف غير صالح.",
            "Success_Details_Updated": "تم تحديث بيانات ملفك الشخصي."
        },
        "ChangePassword": {
            "Title": "تغيير كلمة المرور",
            "Set_Password_Title": "إنشاء كلمة مرور",
            "Label_CurrentPassword": "كلمة المرور الحالية",
            "Label_NewPassword": "كلمة المرور الجديدة",
            "Label_RepeatNewPassword": "تأكيد كلمة المرور الجديدة",
            "Alert_SignInAgain": "يُرجى تسجيل الدخول مرة أخرى لتعيين كلمة مرور جديدة.",
            "ButtonText_UpdatePassword": "تحديث كلمة المرور",
            "ButtonText_SetPassword": "تعيين كلمة المرور",
            "ButtonText_SignInAgain": "تسجيل الدخول مرة أخرى",
            "Error_CurrentPassword_Required": "يُرجى إدخال كلمة المرور الحالية.",
            "Error_CurrentPassword_DoesntMatch": "كلمة المرور التي أدخلتها لا تطابق كلمة المرور الحالية.",
            "Error_NewPassword_Required": "يُرجى إدخال كلمة المرور الجديدة.",
            "Error_NewPassword_6_Characters": "يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل.",
            "Error_RepeatNewPassword_Required": "يُرجى تأكيد كلمة المرور الجديدة.",
            "Error_RepeatNewPassword_DoesntMatch": "كلمتا المرور غير متطابقتين.",
            "Success_Password_Changed": "تم تحديث كلمة المرور بنجاح.",
            "Error_Invalid_CurrentPassword": "كلمة المرور الحالية غير صحيحة."
        },
        "NotificationPreferences": {
            "Title": "تفضيلات الإشعارات",
            "Label_ReceiveUpdatesToggle": "أرغب في تلقي تحديثات من Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "سنرسل إليك أدلة مهنية ونصائح للمقابلات والمزيد."
        },
        "AccountRemoval": {
            "Title": "حذف الحساب",
            "ButtonText_RemoveMyAccount": "حذف حسابي"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "مرحبًا",
        "Subtitle": "أنت على وشك بدء مقابلتك الوظيفية.",
        "TipBox_Title": "إليك بعض النصائح لمساعدتك على تقديم أفضل أداء.",
        "TipBox_Tip1": "أجرِ المقابلة في مكان هادئ يساعدك على التركيز والكتابة براحة.",
        "TipBox_Tip2": "يُفضّل استخدام حاسوب ولوحة مفاتيح للإجابة، إلا إذا كانت الكتابة على الهاتف أكثر راحة لك.",
        "TipBox_Tip3": "يُفضّل أن تكون الإجابات محددة ومفصلة قدر الإمكان، حتى يتمكن Hubert وفريق التوظيف من فهم الخبرات والكفاءات بوضوح.",
        "TipBox_Tip4": "خذ وقتك. لا يوجد حد زمني للمقابلة.",
        "TipBox_Tip5": "يمكنك أخذ استراحة في أي وقت، ثم استئناف المقابلة من حيث توقفت.",
        "TipBox_Tip6": "تعامل مع مقابلة Hubert بالجدية نفسها التي تتعامل بها مع مقابلة يجريها شخص معك.",
        "CheckAdviceArticle_Text1": "لمزيد من النصائح حول تحسين أدائك في المقابلة، اطّلع على هذا",
        "CheckAdviceArticle_Text2": "المقال",
        "CheckAdviceArticle_Text3": "للحصول على نصائح إضافية.",
        "ReadyToGetStarted": "هل أنت جاهز للبدء؟",
        "ORSeparator_Text": "أو",
        "ButtonText_StartInterviewNow": "بدء المقابلة الآن",
        "ButtonText_SetReminder": "ذكّرني لاحقًا",
        "PrivacyPolicyText": "بالنقر على «بدء المقابلة»، فإنك توافق على",
        "PrivacyPolicyLink": " سياسة الخصوصية والشروط والأحكام"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "عمل رائع!",
        "CompletedAlert_Subtitle": "لقد أكملت مقابلتك.",
        "CompletedAlert_Description": "سيُراجع فريق التوظيف جميع الطلبات، وسيتم التواصل عبر البريد الإلكتروني أو الهاتف عند وجود مستجدات.",
        "InterviewNotCompleted": "لم تكتمل هذه المقابلة بعد."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "مركز المساعدة",
            "Subtitle": "اعثر على إجابات لأكثر الأسئلة شيوعًا حول Hubert.",
            "Label_Search": "البحث في الأسئلة الشائعة",
            "ButtonText_Search": "بحث"
        },
        "FAQSection": {
            "Tabs_All": "الكل",
            "Tabs_AboutHubertInterview": "حول مقابلة Hubert",
            "Tabs_TechnicalSupport": "الدعم التقني"
        },
        "StillHaveQuestion": {
            "Title": "هل لديك سؤال آخر؟",
            "Description": "يسعدنا مساعدتك.",
            "DropUsAEmail": "راسلنا على hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "هل يمكنني إجراء المقابلة عبر مكالمة هاتفية بدلًا من الدردشة؟",
                    "a": "تُجرى مقابلات Hubert عبر الدردشة فقط في الوقت الحالي. إذا كانت هناك حالة طبية تمنع إجراء المقابلة بهذه الطريقة، فيُرجى التواصل مباشرةً مع الشركة التي تم التقديم إليها. يقتصر دور Hubert على المقابلة عبر الدردشة."
                },
                {
                    "q": "هل يمكنني إجراء المقابلة بلغة أخرى؟",
                    "a": "تتيح بعض المقابلات اختيار اللغة في البداية. إذا لم يظهر هذا الخيار، فغالبًا ما يكون فهم لغة المقابلة أحد متطلبات الوظيفة. ولأي استفسار آخر، يُرجى التواصل مع الشركة التي تم التقديم إليها."
                },
                {
                    "q": "هل تؤثر الإجابات القصيرة سلبًا في تقييمي؟",
                    "a": "لا، ما دامت إجابتك مناسبة للسؤال. لا يوجد حد أدنى لطول الإجابة، لكن التفاصيل المفيدة تساعد عادةً على توضيح خبرتك."
                },
                {
                    "q": "هل يمكنني إعادة استخدام إجاباتي من مقابلة أخرى مع Hubert؟",
                    "a": "نعم. بعد تسجيل الدخول إلى My Hubert، يمكنك إعادة استخدام إجاباتك السابقة عند التقدم إلى وظيفة مشابهة."
                },
                {
                    "q": "هل سيطّلع شخص على مقابلتي؟",
                    "a": "نعم. نطلب من عملائنا مراجعة المقابلات يدويًا."
                },
                {
                    "q": "أنهيت المقابلة. ماذا يحدث الآن؟",
                    "a": "بعد انتهاء المقابلة، تُرسل النتائج إلى فريق التوظيف عبر نظام طلبات التوظيف. ويمكن للفريق مراجعة الإجابات وتقييم Hubert. وبالاستناد إلى تقييم Hubert الاسترشادي والتقدير المهني، تُحدد الطلبات التي تنتقل إلى الخطوة التالية، التي قد تكون مكالمة هاتفية أو اختبارًا أو مقابلة نهائية."
                },
                {
                    "q": "لدي سؤال عن الخطوات التالية في عملية التوظيف. بمن أتواصل؟",
                    "a": "يُرجى التواصل مع الشركة التي تقدّمت إليها للوظيفة."
                },
                {
                    "q": "كيف تضمنون عدم إدخال تحيّز في عملية التوظيف؟",
                    "a": "الحد من التحيّز جزء أساسي من نهجنا. وبصفته نظامًا موحدًا، يقيّم Hubert الإجابات بدرجة عالية من الاتساق. وقد دُرّبت نماذجنا بمشاركة فرق مراجعة من خلفيات متنوعة. كما لا يستخدم Hubert معلومات مثل الجنس أو العمر أو الأصل العرقي أو الدين أو المظهر، وهي عوامل قد تسهم في التحيّز في المقابلات التقليدية."
                },
                {
                    "q": "هل يمكنني إجراء المقابلة مع شخص بدلًا من Hubert؟",
                    "a": "يُرجى التواصل مع الشركة التي تقدّمت إليها للوظيفة للاستفسار عن ذلك."
                },
                {
                    "q": "هل Hubert إنسان؟",
                    "a": "لا. Hubert نظام حاسوبي مخصص لإجراء المقابلات وتحليلها."
                },
                {
                    "q": "هل يمكنني تغيير إجاباتي لاحقًا؟",
                    "a": "لا. كما في المقابلة التقليدية، لا يمكنك تعديل إجاباتك بعد إرسالها."
                },
                {
                    "q": "كيف أقدّم أداءً جيدًا في مقابلة Hubert؟",
                    "a": "يُرجى قراءة كل سؤال بعناية، واتباع التعليمات، وتقديم أمثلة حقيقية من الخبرة، والإجابة بصدق."
                },
                {
                    "q": "أحتاج إلى وظيفة، بمن أتصل؟",
                    "a": "يُرجى التواصل مع الشركة التي تقدّمت إليها."
                },
                {
                    "q": "أنهيت المقابلة ولم أتلقَّ أي رد. ماذا أفعل؟",
                    "a": "تحدد فرق التوظيف الخطوات التالية بالاستناد إلى تقييم Hubert والتقدير المهني. وقد تكون الخطوة التالية مكالمة هاتفية أو اختبارًا أو مقابلة نهائية. وإذا كانت طلبات أخرى أكثر توافقًا مع الدور، فقد لا ينتقل الطلب إلى المرحلة التالية. ويمكن التواصل مع فريق التوظيف للاستفسار عن حالة الطلب."
                },
                {
                    "q": "لدي خبرة كبيرة، لكنني لم أحصل على الوظيفة. لماذا؟",
                    "a": "قد تكون المنافسة على بعض الوظائف قوية مع وجود عدد كبير من الطلبات المستوفية للمتطلبات. إذا لم يُقبل الطلب، يمكن التواصل مع الشركة للاستفسار عن السبب. ويمكن أيضًا الدخول إلى My Hubert للاطلاع على ملاحظات مستندة إلى إجابات المقابلة واستكشاف فرص عمل أخرى."
                },
                {
                    "q": "كم تستغرق المقابلة؟",
                    "a": "يعتمد ذلك على عدد الأسئلة التي يحددها فريق التوظيف. تستغرق المقابلة عادةً من 10 إلى 25 دقيقة. لا داعي للاستعجال؛ يمكن أخذ استراحة واستئناف المقابلة لاحقًا عند الحاجة."
                },
                {
                    "q": "أين يمكنني معرفة كيفية التعامل مع بياناتي؟",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "لماذا لا أرى مقابلات Hubert السابقة؟",
                    "a": "يُرجى التأكد من استخدام عنوان البريد الإلكتروني نفسه عند التقديم على الوظيفة وعند تسجيل الدخول إلى My Hubert. وينطبق ذلك أيضًا عند تسجيل الدخول باستخدام Google؛ إذ يجب أن يكون بريد Google مطابقًا للبريد المستخدم في التقديم. ويمكن إنشاء حساب باستخدام البريد نفسه المستخدم عند التقديم على الوظيفة."
                },
                {
                    "q": "لماذا لم تصلني رسالة البريد الإلكتروني الخاصة بالمقابلة؟",
                    "a": "يُرجى التحقق من مجلد البريد غير المرغوب فيه، ويمكن أيضًا إضافة hubert@hubert.ai إلى جهات الاتصال. أو يمكن إنشاء حساب على My Hubert باستخدام البريد الإلكتروني المستخدم عند التقديم على الوظيفة، وسيظهر رابط المقابلة هناك."
                },
                {
                    "q": "لا أجد رابط مقابلتي في بريدي الإلكتروني.",
                    "a": "يُرجى التحقق من مجلد البريد غير المرغوب فيه. أو يمكن إنشاء حساب على My Hubert باستخدام البريد الإلكتروني المستخدم عند التقديم على الوظيفة، ثم الانتقال إلى «مقابلاتي» للعثور على الرابط."
                },
                {
                    "q": "هل تعمل المقابلة على الأجهزة المحمولة؟",
                    "a": "نعم. لكن إذا كانت الكتابة على الحاسوب أكثر راحة لك، فننصح باستخدامه."
                },
                {
                    "q": "المقابلة لا تعمل. ماذا أفعل؟",
                    "a": "نأسف لذلك. راسلنا على hubert@hubert.ai وسنساعدك."
                },
                {
                    "q": "أريد حذف حسابي بالكامل من My Hubert. ماذا أفعل؟",
                    "a": "راسلنا على hubert@hubert.ai وسنساعدك."
                },
                {
                    "q": "انقطعت المقابلة. كيف أعود إليها؟",
                    "a": "يمكن العودة إلى المقابلة من حيث توقفت عبر الرابط الموجود في رسالة الدعوة، أو عبر تسجيل الدخول إلى My Hubert واختيار المقابلة من «مقابلاتي»."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "التعلّم مع Hubert",
            "Subtitle": "نصائح لتحسين فرصك في التوظيف وتطوير أدائك المهني.",
            "Label_Search": "ابحث في أدلة المقابلات والمسار المهني",
            "ButtonText_Search": "بحث"
        },
        "TabSelector": {
            "MyFeed": "محتوى مقترح لك",
            "InterviewGuides": "أدلة المقابلات",
            "CareerGuides": "أدلة مهنية"
        },
        "NewestOnTheFeed": "أحدث المحتوى",
        "PickedForMe": "أحدث المقالات",
        "InterviewGuides": "أدلة المقابلات",
        "CareerGuides": "أدلة مهنية"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "العودة إلى جميع المقالات"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "إعادة تعيين كلمة المرور",
        "ResetLinkAlert_Subtitle": "يُرجى استخدام رابط إعادة تعيين كلمة المرور المرسل إلى البريد الإلكتروني لإنشاء كلمة مرور جديدة وتسجيل الدخول.",
        "PasswordNotSetAlert_Message": "لم يتم تعيين كلمة المرور، يُرجى تسجيل الدخول باستخدام ",
        "ResetYourPassword": {
            "MainTitle": "نتائج مقابلة Hubert",
            "Subtitle": "بعد تسجيل الدخول، يمكن الاطلاع على النتائج والحصول على الملاحظات والنصائح والمزيد.",
            "FormSectionTitle": "إعادة تعيين كلمة المرور",
            "Label_NewPassword": "كلمة المرور الجديدة",
            "Label_ConfirmNewPassword": "تأكيد كلمة المرور الجديدة",
            "Error_NewPassword_Required": "يُرجى إدخال كلمة مرور جديدة.",
            "Error_Password_6_Characters": "يجب أن تتكون كلمة المرور الجديدة من 6 أحرف على الأقل.",
            "Error_ConfirmNewPassword_Required": "يُرجى تأكيد كلمة المرور الجديدة.",
            "Error_ConfirmNewPassword_NotMatch": "كلمتا المرور غير متطابقتين.",
            "Error_MalformedResetUrl": "رمز الأمان غير صالح. يُرجى المحاولة مرة أخرى.",
            "Error_ResetPasswordFailed": "تعذر إعادة تعيين كلمة المرور. يُرجى المحاولة مرة أخرى.",
            "Error_WeakPassword": "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل.",
            "Error_InvalidCode_Title": "رابط إعادة تعيين كلمة المرور منتهي الصلاحية أو غير صالح.",
            "Error_InvalidCode_Subtitle": "اطلب رابطًا جديدًا لإعادة تعيين كلمة المرور.",
            "ButtonText_SetNewPassword": "تعيين كلمة مرور جديدة وتسجيل الدخول",
            "ButtonText_RememberYourPassword": "العودة إلى تسجيل الدخول",
            "ButtonText_SignInInstead": "تسجيل الدخول بدلًا من ذلك"
        }
    },
    "PageNotFound": {
        "Title": "الصفحة غير موجودة",
        "Description": "تعذر العثور على الصفحة التي تبحث عنها.",
        "ButtonText_GoToDashboard": "الانتقال إلى لوحة التحكم",
        "ButtonText_GoToLogin": "الانتقال إلى تسجيل الدخول"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "إعادة استخدام الإجابات غير متاحة بعد لهذه المقابلة. نتوقع إتاحة هذه الميزة قريبًا، لكن يمكنك إجراء المقابلة الآن.",
        "DescriptionLine2": "يُرجى استخدام الزر أدناه للانتقال إلى المقابلة.",
        "ButtonText_TakeMeToTheInterview": "الانتقال إلى المقابلة"
    },
    "UnsubscribeFromEmails": {
        "Title": "تأكيد إلغاء الاشتراك",
        "Subtitle": "لن تتلقى بعد الآن رسائل منا بشأن هذه الوظيفة:",
        "SelectTheReason": "يُرجى اختيار سبب من الخيارات أدناه.",
        "ReasonText1": "وجدت وظيفة أخرى.",
        "ReasonText2": "لم أعد مهتمًا بهذه الوظيفة.",
        "ReasonText3": "أخرى",
        "ButtonText_Unsubscribe": "إلغاء الاشتراك في رسائل هذه الوظيفة",
        "Placeholder_YourReason": "سبب إلغاء الاشتراك",
        "Success_Title": "تم إلغاء اشتراكك في رسائل هذه الوظيفة.",
        "Loading": "جارٍ التحميل...",
        "Error_YourReason_Required": "يُرجى إدخال سبب.",
        "Error_ServerIssue": "تعذر إلغاء الاشتراك بسبب خطأ في الخادم."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "إعادة المحاولة"
    },
    "Outreach": {
        "CandidateNotFound": "لم يُعثر على المرشح",
        "CandidateNotFoundDesc": "تعذر العثور على تفاصيل المقابلة المطلوبة.",
        "InterviewEnded": "انتهت المقابلة",
        "InterviewEndedDesc1": "انتهت جلسة المقابلة أو لم تعد متاحة.",
        "InterviewEndedDesc2": "شكرًا على تخصيص وقت للمقابلة. لأي استفسار، يُرجى التواصل مع فريق التوظيف.",
        "ReadyTitle": "هل أنت جاهز للمقابلة، {{firstName}}؟",
        "InvitationDesc": "يدعوك Hubert، نيابةً عن {{companyName}}، إلى مقابلة قصيرة عبر الدردشة تستغرق نحو 1–2 دقيقة.",
        "Button_StartChat": "بدء المقابلة عبر الدردشة",
        "CancelNotice": "البدء من هنا سيؤدي إلى إلغاء المكالمة المجدولة لهذه الوظيفة.",
        "PreferNotToContinue": "هل تفضّل عدم المتابعة؟",
        "DeclineLabel": "لا أرغب في متابعة التقديم لهذا الدور. يُرجى عدم الاتصال بي أو مراسلتي مرة أخرى بشأن هذه الوظيفة.",
        "Button_ConfirmAndDecline": "تأكيد الرفض",
        "Processing": "جارٍ المعالجة...",
        "Toast_DeclineSuccess": "تم رفض دعوة المقابلة.",
        "Toast_CancelVoiceInfo": "تم إلغاء المكالمة. ستتوفر هذه الميزة قريبًا.",
        "Toast_CancelError": "تعذر إلغاء المقابلة. يُرجى المحاولة مرة أخرى.",
        "Footer_WithdrawConsent": "يمكن سحب الموافقة في أي وقت. لمزيد من المعلومات، يُرجى مراجعة  ",
        "Footer_PrivacyPolicySuffix": " — سياسة الخصوصية",
        "Footer_And": " و ",
        "Footer_HubertPrivacyLink": "سياسة الخصوصية والشروط والأحكام الخاصة بـ Hubert",
        "Chat_InterviewWith": "مقابلة مع {{companyName}}",
        "Chat_StatusConnected": "متصل",
        "Chat_StatusError": "حدث خطأ",
        "Chat_StatusDisconnected": "غير متصل",
        "Chat_StatusConnecting": "جارٍ الاتصال...",
        "Chat_ReadyToStart": "هل أنت جاهز لبدء المقابلة؟",
        "Chat_ButtonStart": "بدء المقابلة",
        "Chat_SayHello": "أرسل تحية لبدء المحادثة.",
        "Chat_EmptyState": "أرسل رسالة لبدء المقابلة.",
        "Chat_SelectLanguage": "اختيار اللغة المفضلة",
        "Chat_Placeholder": "الرسالة...",
        "Chat_ButtonSend": "إرسال",
        "Chat_ButtonBack": "عودة",
        "LoadingCandidateDetails": "جارٍ تحميل بياناتك...",
        "FetchingCandidateDetails": "جارٍ جلب بياناتك...",
        "Chat_StatusReady": "في انتظار الاتصال...",
        "Chat_ForbiddenError": "لم تعد هذه المقابلة عبر الدردشة متاحة.",
        "Chat_GeneralError": "تعذر بدء المقابلة عبر الدردشة. يُرجى المحاولة مرة أخرى لاحقًا.",
        "Chat_SelectUiLanguage": "لغة الواجهة",
        "Chat_InterviewTitle": "مقابلة وظيفية"
    }
}
